module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gidoE"))).then(() => parcelRequire('dDqkm'));